import React from 'react'
import Release from 'assets/images/svg/new_release.svg'
import Licence from 'assets/images/svg/licence_green.svg'
import { Link } from 'react-router-dom'
import ServerImage from 'components/server-image/server-image'
import {formatDate, json, showDiscriminate} from 'helpers/data'
import { useTranslation } from 'react-i18next'

const CardProduct = ({logo,name,appName,levelName,usedDevice,numberOfLicenses,date,price,url,newRelease}) => {
  const { t } = useTranslation("browse-apps");

  return (
    <Link to={url} className='cardProduct'>
        <ServerImage src={logo} className='logo'/>
        {newRelease !== 0 &&  <img className='release' src={Release} alt="Release" />} 
        <h1 className='title'>{json(appName)}</h1>
        <p className='name'>{json(name)}</p>
        <p className='levelName'>{json(levelName)}</p>
        <div className='div-licence'>
            <img src={Licence} alt="licence_green" />
            <span> {t("myProducts.license")} </span>
             <span> {usedDevice} / {numberOfLicenses}</span>
        </div>
        <div className='details'>
            <span className='tag'>{json(`${showDiscriminate(`${price?.discrimination}`)}`)}</span>
            <p className='renew'>{t("myProducts.productLicense.renewalCol")}: <span>{formatDate(date)}</span></p>
        </div>
    </Link>
  )
}

export default CardProduct